import React from 'react';
import { Chip } from '@mui/material';

const STAGE_COLORS = {
	Warranty: { bg: '#2e7d32', color: '#fff' },
	Construction: { bg: '#1565c0', color: '#fff' },
	Design: { bg: '#6a1b9a', color: '#fff' },
	Closeout: { bg: '#e65100', color: '#fff' },
	Preconstruction: { bg: '#00695c', color: '#fff' },
};

const StageChip = ({ value }) => {
	if (!value) return null;
	const style = STAGE_COLORS[value] ?? { bg: '#757575', color: '#fff' };
	return (
		<Chip
			label={value}
			size="small"
			sx={{ backgroundColor: style.bg, color: style.color }}
		/>
	);
};

export default StageChip;
